import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTokens } from '../../component-themes';
import { forwardRef } from 'react';
/**
 * Used to display the label for `ProgressStepsStepListStepIndicator`.
 */
export const ProgressStepsStepListStepIndicatorLabel = forwardRef(({ as: Component = 'div', active, state, ...props }, ref) => {
    const tokens = useTokens();
    const activeState = active ? 'active' : 'inactive';
    const interactionState = state === 'initial' ? 'hover' : 'pressed';
    return (_jsx(Component, { css: {
            color: tokens.styles[`progressSteps-stepList-step-indicator-label-${activeState}-${state}-color`],
            opacity: tokens.styles[`progressSteps-stepList-step-indicator-label-${activeState}-${state}-opacity`],
            fontSize: tokens.styles[`progressSteps-stepList-step-indicator-label-${activeState}-${state}-fontSize`],
            fontFamily: tokens.styles[`progressSteps-stepList-step-indicator-label-${activeState}-${state}-fontFamily`],
            fontWeight: tokens.styles[`progressSteps-stepList-step-indicator-label-${activeState}-${state}-fontWeight`],
            lineHeight: tokens.styles[`progressSteps-stepList-step-indicator-label-${activeState}-${state}-lineHeight`],
            letterSpacing: tokens.styles[`progressSteps-stepList-step-indicator-label-${activeState}-${state}-letterSpacing`],
            transition: `all ${tokens.styles[`interaction-${interactionState}-duration`]} ${tokens.styles[`interaction-${interactionState}-timing`]}`,
        }, ...props, ref: ref }));
});
ProgressStepsStepListStepIndicatorLabel.displayName =
    'ProgressStepsStepListStepIndicatorLabel';
